import { observable, action } from 'mobx';
import env  from '../configs/config';
import $ from 'jquery';
import LocalStorageStore from './localStorageStore'


/*eslint no-use-before-define: 0*/
class FrameworkStore {

	@observable loading;

	constructor() {
		this.loading = false;
	}

	@action getFullname = () => {
		return LocalStorageStore.getFullname();
	}

	@action logout = () => {
		return LocalStorageStore.removeToken();
	}

	@action isLoggedIn = () => {
		var exp = LocalStorageStore.getExpiryTime();
		var cur = Math.round((new Date()).getTime()) / 1000;
		var sessionValid = exp > cur;

		if (!sessionValid) {
			this.logout();
		}
		//return sessionValid;
		return true; //TODO: connect to the storage
	}

	@action login = (userName, password) => {
		
		this.loading = true;
		return $.ajax({
			url: env().default.WEBAPI_BASE_URL + '/Application/Login',
			dataType: 'json',
			type: 'POST',
			data: { UserName: userName, Password: password, ApplicationGuid: env().default.APPLICATION_ID },
			context: this,
			success: function (data, textStatus, request) {
				this.loading = false;
				LocalStorageStore.saveToken(data);
			}
		});
	}
}


	export default new FrameworkStore();



// WEBPACK FOOTER //
// ./src/stores/frameworkStore.js